import React, { useState } from 'react'

// EXTERNAL COMPONENTS
import {
  Avatar,
  Button,
  Grid,
  Hidden,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Tooltip,
} from "@material-ui/core"
import { Bag, Search, Copy } from '@ripley-ui/icon'
import CircleContent from '../../../common/components/CustomComponents/CircleContent'

// STYLE
import { SideBannerJss } from './styleJss'

// CONSTANTS
import { DIALOG_STATE_INIT, CHILE } from '../../../../constants'

// COMPONENTS
import ResendEmailForm from '../ResendEmailForm/ResendEmailForm'
import { ConfirmationDialog } from '../../../common/components/Dialog'

const SideBanner = ({country}) => {
  const classes = SideBannerJss()
  const [dialogState, setDialogState] = useState(DIALOG_STATE_INIT)
  const handleSetDialogState = () => setDialogState(DIALOG_STATE_INIT)

  const handleResendEmail = () => {
    setDialogState({
      type: 'primary',
      divider: false,
      noButton: true,
      open: true,
      buttonLabels: {
        onSuccessLabel: 'Reenviar'
      },
      actions: {
        onClose: handleSetDialogState,
        onSuccess: handleSetDialogState
      },
      children: (
        <ResendEmailForm country={country}/>
      ),
    })
  }

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('onboardingss@ripley.com.pe')
  }

  return (
    <>
      <Grid
        className={classes.mainContainer}
        container
        direction="column"
        justifyContent="space-between"
      >
        <Grid container item direction='column' >
          <Grid container item className={classes.marketLogoContainer}>
            <div className={classes.headWrap}>
              <div>
                <span>
                  <Search className={classes.icon + ' ' + classes.search} />
                  <span
                    className={classes.head}>
                    lo tenemos todo
                  </span>
                  <Bag className={classes.icon + ' ' + classes.bag} />
                </span>
              </div>
              <div className={classes.onHead}>
                <span>
                  ¡haz crecer tu negocio!
                </span>
              </div>
              <div className={classes.headBig}>
                <span>
                  Únete al <span className={classes.headBigColor}>marketplace de Ripley.com</span>
                </span>
              </div>
              <div
                className={classes.headLittle}
              >
                <span>
                  ya somos más de 4.000, no te quedes fuera
                </span>
              </div>
            </div>
          </Grid>
          <Hidden smDown>
            <Grid item>
              <List className={classes.list}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography className={classes.headerRegularText}>
                        <b>¿Cómo es el proceso?</b>
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar className={classes.iconContainer}>
                      <CircleContent text='1' />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.listItemTextRegular}>
                        Completa este formulario.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar className={classes.iconContainer}>
                      <CircleContent text='2' />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.listItemTextRegular}>
                        Completa tu perfil de usuario.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar className={classes.iconContainer}>
                      <CircleContent text='3' />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.listItemTextRegular}>
                        Validamos tu información.
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar className={classes.iconContainer}>
                      <CircleContent text='4' />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.listItemTextRegular}>
                        Eres parte del Marketplace Ripley.com !
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Grid>
          </Hidden>
        </Grid>
        {country===CHILE.value?(
          <Grid item>
            <Button
              variant='text'
              onClick={handleResendEmail}
              className={classes.sideBannerTextButton}
            >
              <u>¿No te llegó el correo para<br />
              completar los datos de tu tienda?</u>
            </Button>
          </Grid>
        ):(
          <Grid item>
            <Button
              variant='text'
              onClick={handleResendEmail}
              className={classes.sideBannerTextButton}
            >
              <u>¿No te llegó el correo para<br />
              completar los datos de tu tienda?</u>
            </Button>
            <Tooltip 
              arrow
              className=''
              title={
                <Typography variant='h4'>
                  Copiar correo
                </Typography>
              }
              placement="bottom"
            >
              
              <Button 
                variant='text'
                className={classes.sideBannerTextButton}
                endIcon={<Copy color='#6A148E' type='outlined' />}
                onClick={handleCopyEmail}
              >
                <p>¿Quieres postular desde el extranjero?
                <br />
                Envía un email a <strong>onboardingss@ripley.com.pe</strong></p>
              </Button>
            </Tooltip>
          </Grid>
        )}
      </Grid>
      <ConfirmationDialog
        title={dialogState.title}
        type={dialogState.type}
        divider={dialogState.divider}
        noButton={dialogState.noButton}
        open={dialogState.open}
        maxWidth={dialogState.maxWidth}
        buttonLabels={{
          onCloseLabel: dialogState.buttonLabels.onCloseLabel,
          onSuccessLabel: dialogState.buttonLabels.onSuccessLabel
        }}
        actions={{
          onClose: dialogState.actions.onClose,
          onSuccess: dialogState.actions.onSuccess
        }}
        hasSecondaryButton={dialogState.hasSecondaryButton}
      >
        {dialogState.children}
      </ConfirmationDialog>
    </>
  )
}

export default SideBanner
